(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('vh-atc-label')) return;

    var EVENTS = [
      'variant:update',
      'variantChange',
      'variant:change',
      'change',
      'cart:update',
      'bundle:update'
    ];
    var SKIP = 'svg,[class*="spinner"],[class*="loading"],[class*="icon"]';
    var RETRIES = [0, 200, 600, 1500, 3000, 6000];
    var MAX_RUNS = 60;
    var RUN_WINDOW = 2000;

    function clean(el) {
      if (!el) return '';
      return (el.textContent || '').replace(/\s+/g, ' ').trim();
    }

    /* Every write below is conditional. An unconditional textContent write
       replaces the text node and re-triggers the observer -> infinite loop. */
    function setText(el, val) {
      if (!el) return;
      val = val || '';
      if (el.textContent !== val) el.textContent = val;
    }

    function setHidden(el, val) {
      if (!el) return;
      val = !!val;
      if (el.hidden !== val) el.hidden = val;
    }

    function addClass(el, name) {
      if (!el || !el.classList || el.classList.contains(name)) return;
      el.classList.add(name);
    }

    class VhAtcLabel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.vhEnabled !== 'true') return;

        var json = this.querySelector('[data-vh-variants]');
        try {
          this.variants = json ? JSON.parse(json.textContent) : [];
        } catch (e) {
          this.variants = [];
        }

        this.tpl = this.querySelector('[data-vh-atc-template]');
        if (!this.tpl) return;

        this._watched = [];
        this._runs = 0;
        this._windowStart = Date.now();
        this._schedule = this.schedule.bind(this);

        this._obs = new MutationObserver(this._schedule);
        this._extObs = new MutationObserver(this._schedule);

        this.render();
        this.connect();

        EVENTS.forEach(
          function (t) {
            document.addEventListener(t, this._schedule, true);
          }.bind(this)
        );

        /* Bundle widgets often mount after this element. */
        this._timers = RETRIES.map(
          function (ms) {
            return setTimeout(this._schedule, ms);
          }.bind(this)
        );
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        if (this._obs) this._obs.disconnect();
        if (this._extObs) this._extObs.disconnect();
        if (this._timers) this._timers.forEach(clearTimeout);
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = null;
        if (!this._schedule) return;
        EVENTS.forEach(
          function (t) {
            document.removeEventListener(t, this._schedule, true);
          }.bind(this)
        );
      }

      connect() {
        if (this._obs) this._obs.observe(this, { childList: true, subtree: true });
        if (!this._extObs) return;
        this._watched.forEach(
          function (el) {
            this._extObs.observe(el, {
              childList: true,
              subtree: true,
              characterData: true
            });
          }.bind(this)
        );
      }

      /* Discard records generated by our own writes before re-observing. */
      disconnect() {
        if (this._obs) {
          this._obs.disconnect();
          this._obs.takeRecords();
        }
        if (this._extObs) {
          this._extObs.disconnect();
          this._extObs.takeRecords();
        }
      }

      schedule() {
        if (this._raf) return;
        this._raf = requestAnimationFrame(
          function () {
            this._raf = null;
            this.render();
          }.bind(this)
        );
      }

      /* Circuit breaker: never let a feedback loop lock up the page. */
      tripped() {
        var now = Date.now();
        if (now - this._windowStart > RUN_WINDOW) {
          this._windowStart = now;
          this._runs = 0;
        }
        this._runs += 1;
        if (this._runs <= MAX_RUNS) return false;
        this.teardown();
        if (window.console) {
          console.warn('[vh-atc-label] update loop detected, observers disconnected');
        }
        return true;
      }

      getButton() {
        return (
          this.querySelector('button[type="submit"]') ||
          this.querySelector('[ref="addToCartButton"]') ||
          this.querySelector('button')
        );
      }

      external(selector) {
        if (!selector) return null;
        var scope = this.closest('product-form-component') || this.closest('form');
        var el = null;
        try {
          if (scope) el = scope.querySelector(selector);
          if (!el) el = document.querySelector(selector);
        } catch (e) {
          return null;
        }
        return el;
      }

      watch(el) {
        if (!el || this._watched.indexOf(el) !== -1) return;
        this._watched.push(el);
      }

      render() {
        if (this.tripped()) return;
        var btn = this.getButton();
        if (!btn) return;

        this.disconnect();
        try {
          this.inject(btn);
          this.paint();
        } finally {
          this.connect();
        }
      }

      /* Inline + !important sits above every stylesheet rule, so the theme's
         own button styles (and any !important in them) can't win. */
      skin(btn) {
        var d = this.dataset;
        var from = d.vhGradFrom || '#17120b';
        var to = d.vhGradTo || '#33291a';
        var borderColor = d.vhBorderColor || '#f3ece0';
        var borderWidth = parseFloat(d.vhBorderWidth);
        var pad = parseFloat(d.vhPad);
        var st = btn.style;

        st.setProperty('display', 'flex', 'important');
        st.setProperty('flex-direction', 'column', 'important');
        st.setProperty('align-items', 'center', 'important');
        st.setProperty('justify-content', 'center', 'important');

        /* Own stacking context so the layer can sit above the theme's fill
           but below our label. */
        st.setProperty('position', 'relative', 'important');
        st.setProperty('isolation', 'isolate', 'important');
        st.setProperty('background-color', 'transparent', 'important');
        st.setProperty('background-image', 'none', 'important');
        st.setProperty('border', '0', 'important');

        var layer = btn.querySelector('[data-vh-bg]');
        if (!layer) {
          layer = document.createElement('span');
          layer.className = 'vh-atc-bg';
          layer.setAttribute('data-vh-bg', '');
          layer.setAttribute('aria-hidden', 'true');
          btn.insertBefore(layer, btn.firstChild);
        }
        var ls = layer.style;
        ls.setProperty('background-color', to, 'important');
        ls.setProperty(
          'background-image',
          'linear-gradient(to bottom, ' + from + ' 0%, ' + to + ' 100%)',
          'important'
        );
        if (!isNaN(borderWidth) && borderWidth > 0) {
          ls.setProperty('border-style', 'solid', 'important');
          ls.setProperty('border-width', borderWidth + 'px', 'important');
          ls.setProperty('border-color', borderColor, 'important');
        }

        /* Cache the theme's own padding once, then add to it. Re-reading after
           we have written would compound the extra on every render. */
        if (isNaN(pad) || pad <= 0) return;
        if (!btn.dataset.vhPadBase) {
          var cs = window.getComputedStyle(btn);
          var top = parseFloat(cs.paddingTop) || 0;
          var bottom = parseFloat(cs.paddingBottom) || 0;
          btn.dataset.vhPadBase = top + '|' + bottom;
          /* A fixed height would swallow the extra padding entirely. */
          if (cs.height && cs.minHeight && parseFloat(cs.minHeight) > 0) {
            st.setProperty('min-height', (parseFloat(cs.minHeight) + pad * 2) + 'px', 'important');
          }
        }
        var base = btn.dataset.vhPadBase.split('|');
        st.setProperty('padding-top', (parseFloat(base[0]) + pad) + 'px', 'important');
        st.setProperty('padding-bottom', (parseFloat(base[1]) + pad) + 'px', 'important');
        st.setProperty('height', 'auto', 'important');
      }

      inject(btn) {
        addClass(btn, 'vh-atc-host');
        this.skin(btn);

        Array.prototype.slice.call(btn.childNodes).forEach(function (node) {
          if (node.nodeType === 3) {
            if (!node.textContent.trim()) return;
            var wrap = document.createElement('span');
            wrap.className = 'vh-atc-hidden';
            wrap.textContent = node.textContent;
            node.parentNode.replaceChild(wrap, node);
            return;
          }
          if (node.nodeType !== 1) return;
          if (node.hasAttribute('data-vh-atc')) return;
          if (node.hasAttribute('data-vh-bg')) return;
          if (node.matches && node.matches(SKIP)) return;
          addClass(node, 'vh-atc-hidden');
        });

        var el = btn.querySelector('[data-vh-atc]');
        if (!el) {
          el = this.tpl.content.firstElementChild.cloneNode(true);
          btn.appendChild(el);
        }
        this.el = el;
      }

      currentVariant() {
        var form = this.closest('form');
        var input = form ? form.querySelector('input[name="id"]') : null;
        var id = input ? input.value : null;
        var match = null;
        if (id) {
          match = this.variants.filter(function (v) {
            return String(v.id) === String(id);
          })[0];
        }
        return match || this.variants[0] || null;
      }

      paint() {
        if (!this.el) return;
        var v = this.currentVariant();

        var priceEl = this.external(this.dataset.vhPriceSelector);
        var compareEl = this.external(this.dataset.vhCompareSelector);
        this.watch(priceEl);
        this.watch(compareEl);

        var price = clean(priceEl) || (v ? v.price : '');
        var compare = clean(compareEl) || (v ? v.compare : null);
        if (compare && price && compare === price) compare = null;

        setText(this.el.querySelector('[data-vh-now]'), price);
        setHidden(this.el.querySelector('[data-vh-sep]'), !price);
        setHidden(this.el.querySelector('[data-vh-cur]'), !price);

        var was = this.el.querySelector('[data-vh-was]');
        setText(was, compare || '');
        setHidden(was, !compare);

        var stock = this.el.querySelector('[data-vh-stock]');
        if (!stock) return;

        var threshold = parseInt(this.dataset.vhThreshold || '0', 10);
        var show = v ? !!v.available : true;
        if (threshold > 0 && v) {
          show = show && v.managed && v.qty > 0 && v.qty <= threshold;
        }
        setHidden(stock, !show);
      }
    }

    customElements.define('vh-atc-label', VhAtcLabel);
  })();
  } catch(e) { console.error(e); }
})();

})();
